import React from 'react'
import "./Login.scss";
import logo1 from "../assets/img/Aays.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const Login = () => {

  const { instance } = useMsal(); // Access MSAL instance from context

  const loginBtn = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
  
    } catch (error) {
      console.error("Login failed", error);
    }
  };
  
  return (
    <>
       <div className="Buttons">
        <div className="loginPage">
          <div className="login_body_content">
            <div className="bg-white dark:bg-gray-900 bgColor">
              <div className="login_body_grid">
                <div className="login_info">
                  <div
                    style={{
                      position: "absolute",
                      left: "30px",
                      top: "30px",
                    }}
                  >
                    <img width={120} src={logo1} alt="food" />
                  </div>
                  <div className="heading-section">
                    <h3 className="heading-section-txt">Welcome to</h3>
                    <h3 className="heading-section-txt">AI-Driven Knowledge Sharing for the Future</h3>
                    <h6 style={{color:"white"}}>Bridge skill gaps faster with intelligent, automated knowledge sharing</h6>
                  </div>
                </div>

                <div className="right_grid_align bgColor">
                  <div className="flex-1 login-container">
                    <div className="text-box">
                      <h3 className="text-heading">Login</h3>
                      <p className="text-desc">
                        Welcome to Data world of Aays Supply Chain. Access to this
                        system is limited. Please contact{" "}
                        <span className="text-email">
                          sumit.shekhar@aaysinsight.com
                        </span>{" "}
                        for details.
                      </p>
                    </div>
                    <div className="button-section">
                      <div className="mt-6">
                        <p className="btn-desc">
                          Sign In to access your account!
                        </p>
                        <button onClick={loginBtn} className="btn_login">
                          Sign in
                        </button>
                      </div>

                      <div
                        style={{
                          width: "70%",
                          paddingTop: "1rem",
                          display: "block",
                          margin: "auto",
                        }}
                      >
                        <span
                          id="Login_herf"
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <a
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                              color: "#868383",
                              textDecoration: "none",
                              fontSize: "20px",
                              fontWeight: "500",
                            }}
                            href="mailto:sumit.shekhar@aaysinsight.com?subject=Need Access to the  Data world of Aays Supply Chain Application!"
                          >
                            {" "}
                            Need Access?
                          </a>

                          <a
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                              color: "#868383",
                              textDecoration: "none",
                              fontSize: "20px",
                              fontWeight: "500",
                            }}
                            href="mailto:sumit.shekhar@aaysinsight.com?subject=Need Help On Sign in On  Data world of Aays Supply Chain Applications!"
                          >
                            {" "}
                            Need Help?
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Login
